enum AssetType {
    Vehicle,
    Tyres,
}

export {AssetType};